module.exports = __webpack_public_path__ + "img/hiq-blue.4435e84a.svg";